<template>
  <div class="modal fade" id="contractTemplateModal" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" :key="uniqueKey">

        <div class="modal-header">
          <h5 class="modal-title">
            {{ isEditMode ? 'Editar Modelo de Contrato' : 'Novo Modelo de Contrato' }}
          </h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submit">
            <div class="row">
              <div class="col-md-8">
                <div class="row">
                  <div class="col-md-12">
                    <label class="form-label required">Nome do modelo</label>
                    <input type="text" class="form-control form-control-solid"
                           required placeholder="Ex: Contrato de Adesão ao Plano" v-model="form.template_name"/>
                  </div>

                  <div class="col-md-12 mt-3">
                    <label class="form-label required">Conteúdo do contrato</label>
                    <QuillEditor
                      ref="quillEditor"
                      height="400"
                      :value="form.template_body"
                      :options="editorOptions"
                      class="form-control-solid"
                      @change="onEditorChange"
                    />
                  </div>

                  <div class="col-md-4 mt-3">
                    <label class="form-label">Ativo?</label>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" role="switch"
                             v-model="form.template_active">
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-4">
                <div class="card bg-light">
                  <div class="card-header">
                    <h6 class="card-title mb-0">
                      <i class="bi bi-code-square me-2"></i>
                      Variáveis disponíveis
                    </h6>
                    <small class="text-muted">Clique para inserir no contrato</small>
                  </div>
                  <div class="card-body p-0" style="max-height: 500px; overflow-y: auto;">
                    <div class="accordion accordion-flush" id="variablesAccordion">
                      <div class="accordion-item" v-for="(vars, category) in variables" :key="category">
                        <h2 class="accordion-header">
                          <button class="accordion-button collapsed py-2 px-3" type="button"
                                  data-bs-toggle="collapse" :data-bs-target="'#collapse' + sanitizeId(category)">
                            <i class="bi bi-folder me-2"></i>
                            {{ category }}
                            <span class="badge bg-secondary ms-2">{{ vars.length }}</span>
                          </button>
                        </h2>
                        <div :id="'collapse' + sanitizeId(category)" class="accordion-collapse collapse">
                          <div class="accordion-body py-2 px-3">
                            <div v-for="(variable, index) in vars" :key="index"
                                 class="variable-item mb-2 p-2 bg-white rounded border cursor-pointer"
                                 @click="insertVariable(variable.code)"
                                 :title="variable.description">
                              <div class="d-flex align-items-center">
                                <i class="bi bi-plus-circle text-success me-2"></i>
                                <span class="fw-medium">{{ variable.label }}</span>
                              </div>
                              <small class="text-muted ps-4">{{ variable.description }}</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer mt-3">
              <button type="button" class="btn btn-secondary" @click="closeModal">Cancelar</button>
              <button type="submit" class="btn btn-primary">
                {{ isEditMode ? 'Atualizar' : 'Salvar' }}
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import QuillEditor from "vue-quill-editor/src/editor.vue";

export default {
  name: "ContractTemplateModal",
  props: ['template'],
  components: {
    QuillEditor,
  },
  data() {
    return {
      templateLocal: null,
      form: {
        template_name: null,
        template_body: '',
        template_active: true,
      },
      variables: {},
      templateId: null,
      uniqueKey: Date.now().toString(),
    };
  },
  watch: {
    template: {
      immediate: true,
      handler(newValue) {
        this.templateLocal = newValue;
        this.populateModal();
        this.uniqueKey = Date.now().toString();
      }
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    isEditMode() {
      return this.template !== null;
    },
    editorOptions() {
      return {
        placeholder: 'Digite o conteúdo do contrato aqui...',
        modules: {
          toolbar: {
            container: [
              [{ 'size': ['small', false, 'large', 'huge'] }],
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'align': [] }],
              ['image'],
              ['clean']
            ],
            handlers: {
              image: () => this.imageHandler()
            }
          }
        }
      };
    }
  },
  mounted() {
    this.loadVariables();
    this.uniqueKey = Date.now().toString();
  },
  methods: {
    populateModal() {
      this.templateId = this.templateLocal?.id_contract_template;
      if (!this.templateId) {
        this.resetModal();
        return;
      }

      this.form = {
        template_name: this.templateLocal.template_name,
        template_body: this.templateLocal.template_body,
        template_active: this.templateLocal.template_active,
      };
    },
    loadVariables() {
      http.get(`/places/${this.place.id_place}/contract-templates/variables`)
        .then((response) => {
          this.variables = response.data;
        });
    },
    sanitizeId(text) {
      return text.replace(/[^a-zA-Z0-9]/g, '');
    },
    onEditorChange(event) {
      this.form.template_body = event.html;
    },
    insertVariable(variable) {
      const quill = this.$refs.quillEditor.quill;
      if (quill) {
        const selection = quill.getSelection(true);
        const index = selection ? selection.index : quill.getLength();
        quill.insertText(index, variable);
        quill.setSelection(index + variable.length);
      } else {
        // Fallback: append to template_body
        this.form.template_body = (this.form.template_body || '') + variable;
      }
    },
    imageHandler() {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.click();

      input.onchange = () => {
        const file = input.files[0];
        if (file) {
          // Validar tamanho (máximo 5MB)
          if (file.size > 5 * 1024 * 1024) {
            Alert.error('A imagem deve ter no máximo 5MB.');
            return;
          }

          // Validar tipo de arquivo
          if (!file.type.startsWith('image/')) {
            Alert.error('Por favor, selecione apenas arquivos de imagem.');
            return;
          }

          const reader = new FileReader();
          reader.onload = (e) => {
            const quill = this.$refs.quillEditor.quill;
            if (quill) {
              const range = quill.getSelection(true);
              const index = range ? range.index : quill.getLength();
              quill.insertEmbed(index, 'image', e.target.result);
              quill.setSelection(index + 1);
            }
          };
          reader.readAsDataURL(file);
        }
      };
    },
    async submit() {
      if (!this.form.template_name || !this.form.template_body) {
        Alert.error('Preencha o nome e o conteúdo do modelo.');
        return;
      }

      try {
        if (this.isEditMode) {
          await this.updateTemplate();
        } else {
          await this.createTemplate();
        }

        Alert.success('Modelo salvo com sucesso.');
        this.$emit('templateSaved');
        this.closeModal();
      } catch (e) {
        Alert.error(e.response?.data?.message || 'Erro ao salvar modelo.');
      }
    },
    async createTemplate() {
      await http.post(`/places/${this.place.id_place}/contract-templates`, this.form);
    },
    async updateTemplate() {
      await http.put(`/places/${this.place.id_place}/contract-templates/${this.templateId}`, this.form);
    },
    closeModal() {
      Modal.toggle('#contractTemplateModal');
      this.$emit('onClose');
    },
    resetModal() {
      this.form = {
        template_name: null,
        template_body: '',
        template_active: true,
      };
      this.templateId = null;
    },
  }
}
</script>

<style scoped>
.variable-item {
  cursor: pointer;
  transition: background-color 0.2s;
}

.variable-item:hover {
  background-color: #f0f0f0 !important;
}

.cursor-pointer {
  cursor: pointer;
}
</style>

<style>
.ql-container {
  min-height: 350px;
}

.ql-editor {
  min-height: 350px;
}
</style>

